<template>
  <div class="team-detail">
    <div class="sideNav-box">
      <ui-frame-bg class="btn-back" colorType="blue-light" @click.native="goBack">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">返回</span>
          <span class="label-text">返回</span>
        </div>
      </ui-frame-bg>

      <ui-frame-bg class="navList-box" colorType="blue-light">
        <ul class="navList">
          <!-- 局数标签 -->
          <li
            v-for="(item, key) in sideNav"
            :key="key"
            :class="{ active: mark == item.id }"
            @click="switchMark(item)"
          >
            <ui-frame-bg class="bg-active" colorType="yellow"></ui-frame-bg>
            <div class="label-box">
              <span class="label-shadow">{{ item.name }}</span>
              <span class="label-text">{{ item.name }}</span>
            </div>
          </li>
        </ul>
      </ui-frame-bg>
    </div>
    
    <div class="detail-container">
      <router-view :subTeam="subTeam"></router-view>
      <!-- <div class="switch-navigation">
        <div class="prev" @click="switchTeam('prev')">上个战队</div>
        <div class="next" @click="switchTeam('next')">下个战队</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import * as api from '@/service/index';
import uiFrameBg from "@/components/ui-frame-bg";

export default {
  components: {
    uiFrameBg
  },
  data() {
    return {
      sideNav: [
        {
          id: 'clan',
          name: '战队详情',
          child: 'DetailClan'
        },
        {
          id: 'members',
          name: '队员详情',
          child: 'DetailMembers'
        },
        {
          id: 'fan',
          name: '粉丝排行',
          child: 'DetailFanRanking'
        }
      ],
      mark: 'clan',
      subSeason: `match_${new Date().getFullYear()}`,
      subTeam: {},
      subSeasonID: ''
    }
  },
  computed: {
    ...mapState(['token', 'uid', 'teamsInfo', 'seasonInfo'])
  },
  watch: {
    seasonInfo: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.subSeasonID = newVal.id
          // 获取战队信息
          this.getTeamsInfo()
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.initMark()

    // 触发导航栏的 二级导航
    let obj = { level: 2, name: '战队' }
    this.SET_NAVSTATUS(obj)
  },
  destroyed() {
    // 触发导航栏的 一级导航
    let obj = { level: 1, name: '' }
    this.SET_NAVSTATUS(obj)
  },
  methods: {
    ...mapMutations(['SET_NAVSTATUS']),
    // ...mapActions(["reqTeamsList"]),
    initMark() {
      let routerName = this.$route.name
      // console.log('routerName', routerName)
      switch (routerName) {
        case 'DetailClan':
          this.mark = 'clan'
          break
        case 'DetailMembers':
          this.mark = 'members'
          break
        case 'DetailFanRanking':
          this.mark = 'fan'
          break
        default:
          this.mark = 'clan'
          break
      }
    },
    switchMark(item) {
      // console.log('item', item)
      if (this.mark != item.id) {
        this.mark = item.id
        this.$router.replace({
          name: item.child,
          params: { subTeam: this.subTeam }
        })
      }
    },
    async getTeamsInfo() {
      if(!this.token) return;
      let data = {
        token: this.token,
        seasonId: this.subSeasonID,
        teamCode: this.$route.params.id
      }
      let response = await api.reqTeamInfo(data)
      if (response.status == 200) {
        this.subTeam = response.data
      }
    },
    toDetail(teamCode) {
      this.$router.push({
        name: 'Detail',
        params: { id: teamCode }
      })
    },
    switchTeam(type) {
      let teams = []
      if (this.teamsInfo && this.teamsInfo.length != 0) {
        teams = this.teamsInfo
      } else {
        teams = JSON.parse(localStorage.getItem('sausage-match:teams')) || []
      }
      const this_id = this.$route.params.id
      const this_index = teams.indexOf(
        teams.find((item) => item.teamCode == this_id)
      )

      if (type == 'prev') {
        if (this_index > 0) {
          let to_index = this_index - 1
          let team_code = teams[to_index].teamCode
          this.toDetail(team_code)

          // 获取战队信息
          this.getTeamsInfo()
        }
      } else if (type == 'next') {
        if (this_index < teams.length - 1) {
          let to_index = this_index + 1
          let team_code = teams[to_index].teamCode
          this.toDetail(team_code)

          // 获取战队信息
          this.getTeamsInfo()
        }
      }
    },
    goBack() {
      this.$router.push({
        name: 'Ranking',
        params: {
          records: 2
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/teams/detail';
</style>